import API from '../stores/API'

export type AttachmentOwnerType = 'sample' | 'unit' | 'task'

export interface Attachment {
  attachmentId: number
  ownerType: AttachmentOwnerType
  ownerId: number
  fileName: string
  contentType: string
  size: number
  description?: string
  createdAt: string
}

export interface AttachmentCreateRequest {
  ownerType: AttachmentOwnerType
  ownerId: number
  description?: string
  file: File
}

export const attachmentApi = {
  getByOwner: async (ownerType: AttachmentOwnerType, ownerId: number): Promise<Attachment[]> => {
    const response = await API.get('/attachments', { params: { ownerType, ownerId } })
    return response.data
  },

  create: async (request: AttachmentCreateRequest): Promise<Attachment> => {
    const formData = new FormData()
    formData.append('ownerType', request.ownerType)
    formData.append('ownerId', request.ownerId.toString())
    formData.append('description', request.description || '')
    formData.append('file', request.file)

    const response = await API.post('/attachments', formData)
    return response.data
  },

  getDownloadUrl: (attachmentId: number) =>
    `${import.meta.env.REACT_APP_API_URL}/attachments/${attachmentId}`
}

export default attachmentApi
